// 组织架构 节点类型/公司类型
export const ENTERPRISE_MASTER = 1 // 总公司
export const ENTERPRISE_SUB = 2 // 分公司
export const ENTERPRISE_OTHERS = -1 // 其他 ？？？

// 公司业务类型
export const IDENTITY_SHIP = 3 // 船主
export const IDENTITY_CARGO = 4 // 货主

export const IDENTITY_BROKER = 5 // Broker
export const IDENTITY_OP = 6 // OP

// 船吊类型 0 无船钓; 1 crane; 2 derrick; 3 crane & derrick
export const GEAR_TYPE_GEARLESS = 0 // 无船钓
export const GEAR_TYPE_GRANE = 1 // crane
export const GEAR_TYPE_DERRICK = 2 // derrick
export const GEAR_TYPE_GRANE_AND_DERRICK = 3 // crane & derrick
// 公司注册等级
export const ENTERPRISE_REG_LEVEL_VIRTUAL = 0
export const ENTERPRISE_REG_LEVEL_REG = 1
// 部门功能类型
export const DEPARTMENT_FUNCTION_BUSINESS_CHART = 1 // 负责租船运价及条款的谈判
export const DEPARTMENT_FUNCTION_NON_BUSINESS_CHART = 2 // 不负责租船运价及条款的谈判
// 船主权类型
export const SHIP_TYPE_OWNER = 1 // ：一船东
export const SHIP_TYPE_AS_DISPONENT = 2 // 二船东

// 归属权状态： -3，已出售； -2，已过期； -1，未申请主权(收藏)；0，申请主权中；1，产权权限；2，租赁权限；
export const OWNER_SHIP_STATUS_SOLD = -3
export const OWNER_SHIP_STATUS_EXPIRED = -2
export const OWNER_SHIP_STATUS_NOT_APPLY = -1
export const OWNER_SHIP_STATUS_OWNED = 1
export const OWNER_SHIP_STATUS_DISPONENT = 2

// 公司注册等级描述
export const ABOUT_COMPANY_NAME = {
  [ENTERPRISE_REG_LEVEL_REG]: {
    title: 'RegisteredName',
    tip: 'RegisteredNameTip'
  },

  [ENTERPRISE_REG_LEVEL_VIRTUAL]: {
    title: 'VirtualName',
    tip: 'VirtualNameTip'
  }
}

// 公司业务类型描述
export const COMPANY_CATEGORY = {
  [IDENTITY_SHIP]: { // 3船主
    title: 'ShipPropertyCompany',
    tip: 'ShipownersTip',
    tableTip: 'ShipOwnershipCompany' // 用于公司动态 company category项的翻译标识
  },
  [IDENTITY_CARGO]: { // 4货主
    title: 'CargoPropertyCompany',
    tip: 'CharterersTip',
    tableTip: 'RightOfControlOfCargo'
  },
  privContact: { // 是否有业务联系权 privContact为1表示有
    title: 'BusinessContactCompany',
    tip: 'BusinessContactCompanyTip',
    tableTip: 'CompanyForCharteringBusinessExternalContacts'
  },
  privSign: { // 是否有签约权 privSign为1表示有
    title: 'SigningRightCompany',
    tip: 'SigningRightCompanyTip',
    tableTip: 'UseForCPSigning'
  }
}
// 公司业务类型描述
export const ACCESS_IDENTITY = {
  [IDENTITY_SHIP]: { // 3船主
    title: 'Shipowners',
    tip: 'Based on the  background of   actual ownership of  at least one.'
  },
  [IDENTITY_CARGO]: { // 4货主
    title: 'Charterers',
    tip: 'Based on the background of  traders,manufaters and mills.',
    tableTip: 'RightOfControlOfCargo'
  },
  [IDENTITY_BROKER]: { // BORKER
    title: 'Chartering Brokers',
    tip: ''
  },
  [IDENTITY_OP]: { // OP
    title: 'Chartering Operators',
    tip: '',
    tableTip: 'RightOfControlOfCargo'
  }
}

// 船加访问身份
export const DEPT_IDENTITY = {
  [IDENTITY_SHIP]: { // 3船主
    title: 'Shipowner'
  },
  [IDENTITY_CARGO]: { // 4货主
    title: 'Charterer'
  },
  [IDENTITY_BROKER]: { // Broker
    title: 'CharteringBrokers'
  },
  [IDENTITY_OP]: { // OP
    title: 'CharteringOperators'
  }
}

// 部门功能 描述
export const DEPT_FUN = {
  [DEPARTMENT_FUNCTION_BUSINESS_CHART]: {
    title: 'BusinessOfChartering',
    tip: 'BusinessOfCharteringTip'
  },
  [DEPARTMENT_FUNCTION_NON_BUSINESS_CHART]: {
    title: 'Non-BusinessOfChartering',
    tip: 'Non-BusinessOfCharteringTip'
  }
}

export const COMPANY_POSITION = {
  [ENTERPRISE_MASTER]: {
    title: 'master'
  },
  [ENTERPRISE_SUB]: {
    title: 'sub'
  }
}
// 船加访问身份
export const OFFER_ACCEPTED = 0 // 船主
export const OFFER_REJECTED = 1 // 货主
export const OFFER_AWAITING = 2 // 货主

export const OFFER_STATE = {
  [OFFER_ACCEPTED]: { // 3船主
    title: 'Accepted'
  },
  [OFFER_REJECTED]: { // 4货主
    title: 'Rejected'
  },
  [OFFER_AWAITING]: { // Broker
    title: 'Awaiting'
  }
}

const NAVIGATION = 143 // 航区
const PORT_POSITION = 142 // 港口经纬度
const SUGGESTION = 135 // 意见建议
export const QUESTION_TYPE = {
  [NAVIGATION]: {
    id: NAVIGATION,
    type: 'navigation'
  },
  [PORT_POSITION]: {
    id: PORT_POSITION,
    type: 'portPosition'
  },
  [SUGGESTION]: {
    id: SUGGESTION,
    type: 'suggestion'
  }
}
